import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SearchCriteria } from '@shared/models/pagination.model';
import { BaseService } from '@shared/services/base.service';
import { Observable, map } from 'rxjs';

import { PrintShelfBarcodeRequest } from '../models/print-shelf-barcode';
import { ShelfListSearchCriteria, ShelfSequenceList } from '../models/shelf-list.model';

@Injectable({
  providedIn: 'root'
})
export class ShelfService extends BaseService {
  public override headers: HttpHeaders;

  constructor(private readonly http: HttpClient) {
    super();
    this.envService = this.env.services.shelf;
    this.headers = new HttpHeaders(this.envService.headers);
  }

  public list(criteria: ShelfListSearchCriteria): Observable<any> {
    const storeNo = this.retrieveStore().storeNo;
    const url = this.getFullUrl(this.envService.list, {
      storeNo
    });
    const params = this.getParams(criteria, true);

    return this.http
      .get<any>(url, {
        headers: this.loaderHeaders(null),
        observe: 'body',
        params
      })
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  public view(request): Observable<any> {
    let storeNo = this.retrieveStore().storeNo;
    let refId = request.refId;
    const url = this.getFullUrl(this.envService.view, {
      storeNo,
      refId
    });

    return this.http.post<any>(url, request, {
      headers: this.loaderHeaders(),
      observe: 'body',
      responseType: 'json'
    });
  }

  sequenceList(payload: any): Observable<ShelfSequenceList[]> {
    const url = this.getFullUrlWithStoreNo(this.envService.shelfSequenceList);
    const params = this.getParams(payload, true);

    return this.http.get<ShelfSequenceList[]>(url, {
      headers: this.loaderHeaders(),
      observe: 'body',
      params
    });
  }

  shelfSequenceSubmit(payload: any): Observable<any> {
    const url = this.getFullUrlWithStoreNo(this.envService.shelfSequenceSubmit);
    return this.http.post(url, payload, { headers: this.loaderHeaders() });
  }

  getShelfBarcodePrintList(payload: SearchCriteria): Observable<any> {
    const url = this.getFullUrlWithStoreNo(this.envService.shelfBarcodePrintList);
    const params = this.getParams(payload, true);

    return this.http.get<any>(url, {
      headers: this.loaderHeaders(),
      observe: 'body',
      params
    });
  }

  onPrintShelfBarcode(payload: PrintShelfBarcodeRequest): Observable<any> {
    const url = this.getFullUrlWithStoreNo(this.envService.shelfBarcodePrint);

    return this.http.post<any>(url, payload, {
      headers: this.loaderHeaders(0),
      observe: 'body',
      responseType: 'json'
    });
  }
}
